import { a as TailwindElement, x, A } from '../../index-e3189942.js';
import { e, a as e$1 } from '../../directive-9ec64c08.js';
import { t } from '../../state-7fde94d1.js';
import { c as customClassMap } from '../../index-714323c9.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoInput = class extends TailwindElement {
  constructor() {
    super(...arguments);
    this.value = "";
    this.name = "";
    this.type = "text";
    this.placeholder = "";
    this.label = "";
    this.autocomplete = "on";
    this.id = "";
    this.ref = void 0;
    this.accept = void 0;
    this.description = "";
    this.error = "";
    this.unit = "";
    this.customClass = "";
    this.isFullWidth = false;
    this.isReadonly = false;
    this.isDisabled = false;
    this.autofocus = false;
    this.max = void 0;
    this.min = void 0;
    this.hasHocus = false;
    this.hasHighlight = false;
    this.defaultInputStyles = `bg-neutral-100 text-neutral-20 paragraph-inter-14-regular px-4 py-3
    border border-solid h-[48px] placeholder:text-neutral-70
    outline-none transition transition-all duration-150 appearance-none`;
    this.defaultUnitStyles = `paragraph-inter-12-regular text-neutral-60 flex px-3.5 items-center relative
    border border-solid h-[48px] transition transition-all duration-150
    rounded-r-12 border-l-0 before:bg-neutral-90 before:absolute before:top-[calc(50%-12px)] before:left-0
    before:w-[1px] before:h-[24px] whitespace-nowrap`;
  }
  // @input works better in vue
  inputTemplate() {
    return x`
      <input
        name=${this.name}
        type=${this.type}
        value=${this.value}
        placeholder=${this.placeholder}
        ?autofocus=${this.autofocus}
        min=${this.min}
        max=${this.max}
        autocomplete=${this.autocomplete}
        ref=${this.ref}
        id=${this.id || this.name}
        data-testid=${this.name ? `input-${this.name}` : "input"}
        accept=${this.accept}
        ?readonly=${this.isReadonly ? true : void 0}
        ?disabled=${this.isDisabled ? true : void 0}
        class=${customClassMap({
      [this.defaultInputStyles]: true,
      [this.error === "" ? "border-neutral-90" : "border-red-85"]: !this.hasHighlight,
      [this.error === "" ? "border-neutral-35" : "border-red-65"]: this.hasHighlight,
      ["rounded-l-12 border-r-0"]: this.unit !== "",
      ["rounded-12"]: this.unit === "",
      ["w-full"]: this.isFullWidth,
      ["w-[350px]"]: !this.isFullWidth && this.unit === "",
      ["w-[300px]"]: !this.isFullWidth && this.unit !== "",
      [this.customClass]: !!this.customClass
    })}
        @focus=${this.handleFocus}
        @input=${this.handleInput}
        @change=${this.handleChange}
        @blur=${this.handleBlur}
        @keyup=${this.handleKeyUp}
        @keydown=${this.handleKeyDown}
        @keypress=${this.handleKeyPress}
        @mouseenter=${this.handleMouseOver}
        @mouseleave=${this.handleMouseOut}
      />
    `;
  }
  labelTemplate() {
    return x`
      <label
        for=${this.name}
        class="heading-inter-14-bold text-neutral-20 pb-2 block"
        >${this.label}</label
      >
    `;
  }
  descriptionTemplate() {
    return x`
      <div class="paragraph-inter-12-regular text-neutral-20 pb-2">
        ${this.description ?? A}
      </div>
    `;
  }
  errorTemplate() {
    return x`<div class="paragraph-inter-12-regular text-red-65 pt-2">
      ${this.error}
    </div>`;
  }
  unitTemplate() {
    return x`<div
      class=${customClassMap({
      [this.defaultUnitStyles]: true,
      [this.error === "" ? "border-neutral-90" : "border-red-85"]: !this.hasHighlight,
      [this.error === "" ? "border-neutral-35" : "border-red-65"]: this.hasHighlight
    })}
      @mouseenter=${this.handleMouseOver}
      @mouseleave=${this.handleMouseOut}
    >
      ${this.unit}
    </div>`;
  }
  handleFocus() {
    this.hasHocus = true;
    this.hasHighlight = true;
  }
  handleBlur(event) {
    this.hasHocus = false;
    this.hasHighlight = false;
    const target = event.target;
    const blurEvent = new CustomEvent("on-blur", {
      detail: {
        value: target.value,
        event
      },
      bubbles: false,
      composed: true
    });
    this.dispatchEvent(blurEvent);
  }
  handleChange(event) {
    const target = event.target;
    const changeEvent = new CustomEvent("on-change", {
      detail: {
        value: target.value,
        event
      },
      bubbles: false,
      composed: true
    });
    this.dispatchEvent(changeEvent);
  }
  handleInput(event) {
    const target = event.target;
    const changeEvent = new CustomEvent("on-input", {
      detail: {
        value: target.value,
        event
      },
      bubbles: false,
      composed: true
    });
    this.dispatchEvent(changeEvent);
  }
  handleKeyUp(event) {
    const target = event.target;
    const keyEvent = new CustomEvent("on-key-up", {
      detail: {
        value: target.value,
        event
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(keyEvent);
  }
  handleKeyDown(event) {
    const target = event.target;
    const keyEvent = new CustomEvent("on-key-down", {
      detail: {
        value: target.value,
        event
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(keyEvent);
  }
  handleKeyPress(event) {
    const target = event.target;
    const keyEvent = new CustomEvent("on-key-press", {
      detail: {
        value: target.value,
        event
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(keyEvent);
  }
  handleMouseOver() {
    this.hasHighlight = true;
  }
  handleMouseOut() {
    if (!this.hasHocus) {
      this.hasHighlight = false;
    }
  }
  render() {
    return x`
      <div>
        ${this.label ? this.labelTemplate() : A}
        ${this.description ? this.descriptionTemplate() : A}
        <div class="flex">
          ${this.inputTemplate()} ${this.unit ? this.unitTemplate() : A}
        </div>
        ${this.error ? this.errorTemplate() : A}
      </div>
    `;
  }
};
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "value", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "name", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "type", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "placeholder", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "label", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "autocomplete", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "id", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "ref", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "accept", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "description", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "error", 2);
__decorateClass([
  e({ type: String })
], LuksoInput.prototype, "unit", 2);
__decorateClass([
  e({ type: String, attribute: "custom-class" })
], LuksoInput.prototype, "customClass", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-full-width" })
], LuksoInput.prototype, "isFullWidth", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-readonly" })
], LuksoInput.prototype, "isReadonly", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-disabled" })
], LuksoInput.prototype, "isDisabled", 2);
__decorateClass([
  e({ type: Boolean })
], LuksoInput.prototype, "autofocus", 2);
__decorateClass([
  e({ type: Number })
], LuksoInput.prototype, "max", 2);
__decorateClass([
  e({ type: Number })
], LuksoInput.prototype, "min", 2);
__decorateClass([
  t()
], LuksoInput.prototype, "hasHocus", 2);
__decorateClass([
  t()
], LuksoInput.prototype, "hasHighlight", 2);
LuksoInput = __decorateClass([
  e$1("lukso-input")
], LuksoInput);

export { LuksoInput };
